export async function generateRecaptchaToken(recaptchaEnabled, recaptchaPublicKey, signal) {
  return new Promise((resolve, reject) => {
    if (!recaptchaEnabled) {
      console.warn('recaptcha is not enabled!')
      return resolve('')
    }

    if (!recaptchaPublicKey) {
      return reject(new Error('recaptchaPublicKey is missing!'))
    }

    if (signal?.aborted) {
      return reject(new Error('Operation aborted'))
    }

    const onAbort = () => reject(new Error('Operation aborted'))
    signal?.addEventListener('abort', onAbort, { once: true })

    grecaptcha.ready(() => {
      if (signal?.aborted) {
        signal.removeEventListener('abort', onAbort)
        return reject(new Error('Operation aborted'))
      }

      grecaptcha.execute(recaptchaPublicKey, { action: 'submit' })
        .then(token => {
          signal?.removeEventListener('abort', onAbort)
          console.info('reCAPTCHA token generated successfully')
          resolve(token)
        })
        .catch(err => {
          signal?.removeEventListener('abort', onAbort)
          console.error('Failed to generate reCAPTCHA token', err)
          reject(err)
        })
    })
  })
}
